import { AREAS_BY_ID } from '../../model/areas';
import './restaurant-card.css';

import LocationIcon from '../../../uber-assets/location-icon.svg';
import { INFO_ICON, INSTA_ICON, SHARE_ICON } from '../../../uber-assets/inline-svgs';
import FinalistRibbon from '../../../uber-assets/finalist-ribbon.svg';
import WinnerRibbon from '../../../uber-assets/winner-ribbon.svg';

import MainRibbon1 from '../../../uber-assets/ribbon_winner.png';
import MainRibbon2 from '../../../uber-assets/ribbon_1strunnerup.png';
import MainRibbon3 from '../../../uber-assets/ribbon_2ndrunnerup.png';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { CustomDot } from '../carousel/custom-dot';
import { FORCE_RESTAURANT_PLACEHOLDER, PHASES, CACHE_BUSTING_VERSION } from '../../model/phases';
import { useEffect, useState } from 'react';
import { getRestaurantUrlSlug, RESTAURANT_PLACEHOLDER } from '../../model/restaurants';

import { fb } from '../../controller/ShareController';
import { FB_HASHTAGS, SHARE_MESSAGE, SHARE_RAW_HASHTAGS } from "../../model/sharing";

export function RestaurantCard({ showTrailblazerWinnerBanner, restaurant, trailblazer, infoFunction, instagramFunction, orderFunction, voteFunction, phase, alreadyVoted, finalist, animIndex, showWinner, icon, category, showBigRibbon, position, bigCard }) {
    // console.log('Rendering RestaurantCard for', restaurant?.name || trailblazer?.name || 'unknown', 'with restaurant data', restaurant, 'and trailblazer data', trailblazer);
    
    let trailblazerWinner = false;
    if (!restaurant && trailblazer) {
        restaurant = trailblazer;
        trailblazerWinner = showTrailblazerWinnerBanner ?? restaurant.isWinner;
    }

    const [autoPlay, setAutoPlay] = useState(false);
    const hasMultipleImages = Array.isArray(restaurant.image) && restaurant.image.length > 1;

    const share = (restaurantData, restaurantId = -1) => {
        let shareLink = 'https://www.ubereatsawards.com/';
        if (restaurantId !== -1) {
            shareLink += '?r=' + (getRestaurantUrlSlug(restaurantId) || restaurantId);
        }
        // console.log('Sharing restaurant', restaurantData, 'with ID', restaurantId, 'and link', shareLink);
        const customMessage = restaurantId === -1 ? ' ' : ' I voted for ' + restaurantData.name + ', who will you vote for? ';
        const shareTag = restaurantId === -1 ? FB_HASHTAGS : FB_HASHTAGS + ' #VoteNow #' + restaurantData.name.replace(/ /g, '');
        fb.share_ui(SHARE_MESSAGE + customMessage + SHARE_RAW_HASHTAGS, shareTag, shareLink);
    }

    useEffect(() => {
        let t = setTimeout(() => {
            setAutoPlay(true);
        }, Math.floor(Math.random() * 3000));
        return () => {
            clearTimeout(t);
        }
    }, []);

    let smallBio = FORCE_RESTAURANT_PLACEHOLDER ? RESTAURANT_PLACEHOLDER.description : restaurant.description;
    // remove any double spaces
    smallBio = smallBio.replace(/\s+/g, ' ');
    // remove any new lines
    smallBio = smallBio.replace(/\n/g, ' ');
    // remove any leading or trailing spaces
    smallBio = smallBio.trim();
    let addEllipsis = false;
    // if the small bio is longer than 90 characters, truncate it to 90 characters and add '...'
    if (smallBio.length > 95) {
        smallBio = smallBio.substr(0, 95).trim();
        addEllipsis = true;
    }
    // Trim it to the last space so it doesn't cut off a word
    if (addEllipsis) {
        smallBio = smallBio.substr(0, smallBio.lastIndexOf(' ')).trim();
    }
    if (addEllipsis) {
        smallBio += '...';
    }    

    return (
        <div className={`${trailblazer ? 'trailblazer-card-anim ' : 'restaurant-card-anim '}restaurant-card${bigCard ? ' big' : ''} card-anim-start`}>
            {trailblazerWinner &&
                <div className="winner-card__top-banner"><img src={'./img/' + icon} alt={category} /><p>{category} Winner!</p></div>
            }
            {(!Array.isArray(restaurant.image) || FORCE_RESTAURANT_PLACEHOLDER) &&
                <div className={`restaurant-card__image${trailblazerWinner ? ' square-image' : ''} clickable`} onClick={() => infoFunction(restaurant)} style={{backgroundImage: `url(./img/${FORCE_RESTAURANT_PLACEHOLDER ? RESTAURANT_PLACEHOLDER.image[0] : restaurant.image})`}}></div>
            }
            {Array.isArray(restaurant.image) && !FORCE_RESTAURANT_PLACEHOLDER &&
                <Carousel
                    swipeable={hasMultipleImages}
                    draggable={hasMultipleImages}
                    showDots={hasMultipleImages}
                    customDot={<CustomDot />}
                    arrows={hasMultipleImages}
                    responsive={{all: {breakpoint:{min: 0, max: 1000000}, items: 1}}}
                    ssr={false} // means to render carousel on server-side.
                    infinite={true}
                    autoPlay={false /*restaurant.image.length > 1 ? autoPlay : false*/}
                    autoPlaySpeed={3000}
                    keyBoardControl={false}
                    transitionDuration={500}
                    containerClass="restaurant-card__image"
                    dotListClass=''
                >
                    {
                        restaurant.image.map((image, index) => {
                            return (
                                <div key={index} className="restaurant-card__image carousel-inner clickable" onClick={() => infoFunction(restaurant)} style={{backgroundImage: `url(./img/restaurants/${image}?v=${CACHE_BUSTING_VERSION})`}}></div>
                            )
                        })
                    }
                </Carousel>
            }
            <div className="restaurant-card__info">
                <h2 className="restaurant-card__info__name"><span className='clickable' onClick={() => infoFunction(restaurant)}>{FORCE_RESTAURANT_PLACEHOLDER ? RESTAURANT_PLACEHOLDER.name : restaurant.name}</span></h2>
                <div className="restaurant-card__info__location">
                    <img className='small-info-icon' src={LocationIcon} alt='Location icon' />
                    <p>{!!restaurant.region ? AREAS_BY_ID[restaurant.region].label : restaurant.location}</p>
                </div>
                <div className='small-bio'>{smallBio}</div>
                <div className='small-bio-read-more' onClick={() => infoFunction(restaurant)}>Read more</div>
                <div className='grow'></div>
                <div className={`restaurant-card__info__buttons${phase === PHASES.VOTE ? ' top-row' : ''}`}>
                    {/* <button className="restaurant-card__info__buttons__info square light" onClick={() => infoFunction(restaurant)}>{INFO_ICON}</button> */}
                    {/* <button className="restaurant-card__info__buttons__info square light" onClick={() => share(restaurant, restaurant.id)}>{SHARE_ICON}</button> */}
                    {restaurant?.instagram !== '' && restaurant?.instagram !== undefined && restaurant?.instagram !== null && !restaurant?.instagram?.endsWith('instagram.com/') && !restaurant?.instagram?.endsWith('instagram.com') &&
                        <button className="restaurant-card__info__buttons__instagram square light" onClick={() => instagramFunction(restaurant)}>{INSTA_ICON}</button>
                    }
                    <button className={`restaurant-card__info__buttons__order${phase === PHASES.VOTE ? ' light' : ' black'} mob-hide order-button`} onClick={() => orderFunction(restaurant)}>Order on Uber Eats</button>
                    {phase === PHASES.VOTE &&
                        <>
                            {!alreadyVoted &&
                                <button className="restaurant-card__info__buttons__vote-inline black mob-show" onClick={() => voteFunction(restaurant.id, restaurant.region, restaurant.name)}>Vote now</button>
                            }
                            {alreadyVoted &&
                                <div className='voted-holder inline mob-show'>Thanks for voting</div>
                            }
                        </>
                    }
                    {phase !== PHASES.VOTE &&
                        <button className="restaurant-card__info__buttons__vote-inline black mob-show order-button" onClick={() => orderFunction(restaurant)}>Order on Uber Eats</button>
                    }
                </div>
                {phase === PHASES.VOTE &&
                    <div className="restaurant-card__info__buttons mob-hide">
                        {!alreadyVoted &&
                            <button className="restaurant-card__info__buttons__vote black" onClick={() => voteFunction(restaurant.id, restaurant.region, restaurant.name)}>Vote now</button>        
                        }
                        {alreadyVoted &&
                            <div className='voted-holder under'>Thanks for voting</div>
                        }
                    </div>
                }
            </div>
            {!showBigRibbon && finalist && !trailblazerWinner &&
                <img className='card-ribbon' src={(showWinner && restaurant.isWinner) ? WinnerRibbon : WinnerRibbon/*FinalistRibbon*/} alt='Finalist' />
            }
            {showBigRibbon && position === 1 &&
                <img className='card-ribbon-big' src={MainRibbon1} alt='Winner' />
            }
            {showBigRibbon && position === 2 &&
                <img className='card-ribbon-big' src={MainRibbon2} alt='Runner-up' />
            }
            {showBigRibbon && position === 3 &&
                <img className='card-ribbon-big' src={MainRibbon3} alt='Third place' />
            }
        </div>
    );
}
